<div id="main" class="internal">
  <div id="estrazione" class="section estrazione">
    <div class="content-body">
      <div class="title">
        <h1>{{ "extraction.title" | translate }}</h1>
      </div>
      <div class="content">
        <form class="form" [formGroup]="form" (ngSubmit)="Search()">
          <div class="search">
            <div class="fieldset">
              <label for="bookings">{{
                "extraction.select_restaurant" | translate
              }}</label>
              <p-select
                formControlName="selectedRestaurant"
                [options]="restaurants"
                [filter]="true"
                optionLabel="dropdownLabel"
                [style]="{ width: '100%' }"
                placeholder="{{ 'extraction.select_restaurant' | translate }}"
              />
            </div>
          </div>
          <div class="double">
            <div class="fieldset">
              <label for="date">{{
                "extraction.select_start_date" | translate
              }}</label>
              <p-datepicker
                formControlName="startDate"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [minDate]="retentionDate"
                inputId="date"
                [style]="{ width: '100%' }"
                [firstDayOfWeek]="1"
                selectOtherMonths="true"
              />
            </div>
            <div class="fieldset">
              <label for="date">{{
                "extraction.select_end_date" | translate
              }}</label>
              <p-datepicker
                formControlName="endDate"
                [iconDisplay]="'input'"
                [showIcon]="true"
                inputId="date"
                [minDate]="
                  form.value.startDate ? form.value.startDate : retentionDate
                "
                [style]="{ width: '100%' }"
                [firstDayOfWeek]="1"
                selectOtherMonths="true"
              />
            </div>
          </div>
          <div class="buttons">
            @if (!loaded){

            <button class="costa-button outline" type="button" (click)="Back()">
              {{ "cancel" | translate }}
            </button>
            }
            <button class="costa-button" [disabled]="!form.valid" type="submit">
              {{ "search" | translate }}
            </button>
          </div>
        </form>
        @if (loaded) {
        <div class="table extraction">
          <p>{{ "extraction.bookings" | translate }}</p>
          <div class="ca-card">
            <p-table
              [value]="bookings"
              [paginator]="true"
              [rows]="5"
              [tableStyle]="{ width: '100%' }"
              styleClass="p-datatable-sm p-datatable-striped"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="reservation_date">
                    {{ "extraction.reservation_date" | translate }}
                    <p-sortIcon field="reservation_date" />
                  </th>
                  <th pSortableColumn="slot_start_datetime">
                    {{ "extraction.slot_date" | translate }}
                    <p-sortIcon field="slot_start_datetime" />
                  </th>
                  <th pSortableColumn="id_cabin">
                    {{ "extraction.cabin_id" | translate }}
                    <p-sortIcon field="id_cabin" />
                  </th>
                  <th pSortableColumn="passenger_name">
                    {{ "extraction.passenger_name" | translate }}
                    <p-sortIcon field="passenger_name" />
                  </th>
                  <th pSortableColumn="age">
                    {{ "extraction.age" | translate }}
                    <p-sortIcon field="age" />
                  </th>
                  <th pSortableColumn="costa_club_level">
                    {{ "extraction.costa_club_level" | translate }}
                    <p-sortIcon field="costa_club_level" />
                  </th>
                  <th pSortableColumn="badge_number">
                    {{ "extraction.badge_number" | translate }}
                    <p-sortIcon field="badge_number" />
                  </th>
                  <th pSortableColumn="attendees">
                    {{ "extraction.attendees_number" | translate }}
                    <p-sortIcon field="attendees" />
                  </th>
                  <th pSortableColumn="table_name">
                    {{ "extraction.table_name" | translate }}
                    <p-sortIcon field="table_name" />
                  </th>
                  <th pSortableColumn="myitalian">
                    {{ "extraction.myitalian" | translate }}
                    <p-sortIcon field="myitalian" />
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.reservation_date }}</td>
                  <td>{{ product.slot_start_datetime }}</td>
                  <td>{{ product.id_cabin }}</td>
                  <td>{{ product.passenger_name }}</td>
                  <td>{{ product.age }}</td>
                  <td>{{ product.costa_club_level }}</td>
                  <td>{{ product.badge_number }}</td>
                  <td>{{ product.attendees }}</td>
                  <td>{{ product.table_name }}</td>
                  <td>{{ product.myitalian }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="10">
                    <div class="message">
                      <div class="icon">
                        <img
                          src="../../../assets/images/Info.svg"
                          alt="Info icon"
                        />
                      </div>
                      <div
                        class="text"
                        [innerHTML]="
                          'passenger_reservation.no_reservations' | translate
                        "
                      ></div>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="buttons">
          <button class="costa-button outline" type="button" (click)="Back()">
            {{ "cancel" | translate }}
          </button>
          <button
            class="costa-button outline"
            type="button"
            [disabled]="bookings.length == 0"
            (click)="DownloadReport()"
          >
            {{ "extraction.download_report" | translate }}
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</div>
